var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center align-items-center slider-chat-show-button",on:{"click":_vm.toggleChat}},[_c('Icon',{attrs:{"name":_vm.sliderChatIsShow ? 'arrow-right' : 'chat'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }